/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Color_OrangeInputs */

const en_booking_color_orange = /** @type {(inputs: Booking_Color_OrangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Orange`)
};

const pl_booking_color_orange = /** @type {(inputs: Booking_Color_OrangeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pomarańczowy`)
};

/**
* | output |
* | --- |
* | "Orange" |
*
* @param {Booking_Color_OrangeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const booking_color_orange = /** @type {((inputs?: Booking_Color_OrangeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Color_OrangeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_booking_color_orange(inputs)
	return en_booking_color_orange(inputs)
});